










































import { Component, Prop, Vue } from "vue-property-decorator";
import {ProductStatusItem} from "@/interfaces/ContentsParams";

@Component
export default class ProductContentsTexts extends Vue {
  @Prop({ default: null }) productName: string;
  @Prop({ default: null }) textContentsHtml: string;
  @Prop({ default: null }) productStatus: ProductStatusItem[];
  @Prop({ default: null }) price: string;
  @Prop({ default: null }) tax: string;
  @Prop({ default: null }) link: string;
  @Prop({ default: 'BUY' }) linkLabel: string;
}
